<app-font-size-controls [fontSize]="fontSize$ | async" [isCollapsed]="isCollapsible()"></app-font-size-controls>
